<div class="overlay-loading">
  <div class="spinner-container">
    <i class="pi pi-spin pi-spinner fs-4"></i>
  </div>
</div>